import React from "react";
import "./Platfrom.css";
import { Link } from "react-router-dom";// for button


const handleScrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" }); // Scrolls smoothly to top
};

const Platfrom = () => {
  return (
    <div className="c">
      <div className="h">
        We run a FinOps community with 10,000+ members
        
      </div>
      <h2 className="title1">Supported platforms</h2>
      <div style={{ textAlign: "center" }}></div>
      <div className="platforms">
<img src="/image/aws.png" alt="AWS" className="platformLogo" />
<img src="/image/Azure.webp" alt="Microsoft Azure" className="platformLogo" />
<img src="/image/googlecloud.png" alt="Google Cloud" className="platformLogo" />
<img src="/image/alibaba.png" alt="Alibaba Cloud" className="platformLogo" />
<img src="/image/kubernets.png" alt="Kubernetes" className="platformLogo" />

      </div>
      <div className="chatContainer">
       
        <button className="chatButton"  onClick={handleScrollToTop}>
  <Link to="/contact" style={{ textDecoration: "none", color: "white" }}>
  Any questions? Let's chat
  </Link>
</button>
      </div>

      
    </div>
  );
};

export default Platfrom;